import React from 'react'

import './HistoriqueItem.scss'
import {HistoriqueOrderModel} from "../../Models/HistoriqueOrderModel";
import {useTranslation} from "react-i18next";
import {useFormatCurrency} from "../../hooks/useFormatCurrency";

interface MenuItemProps {
    order: HistoriqueOrderModel
    onClick: () => void
}

const HistoriqueItem: React.FC<MenuItemProps> = ({order, onClick}: MenuItemProps) => {
    const {t} = useTranslation('historique')
    const formatCurrency = useFormatCurrency()

    return (
        <div className="historiqueItem">
            {
                order && (
                    <>
                        <div className="historiqueItem__cadre">
                            <img
                                src={order.image}
                                alt="item"
                            />
                        </div>
                        <div className="historiqueItem__infos">
                            <div className="historiqueItem__infos__top">
                                <p className="historiqueItem__infos__top--name">#{order.reference}</p>
                                <p className="historiqueItem__infos__top--price">{formatCurrency(order.priceTTC)}</p>
                            </div>
                            <p className="historiqueItem__infos--porte">{order.pdvName} <span onClick={onClick}>{t('item.viewQrCode')}</span></p>
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default HistoriqueItem;
